import React, {Component} from 'react';

const ServiceCards = ({cardList}) => {
    const services = cardList.map((card, id )=> {
        return (
            <div className="ServiceCard flexColumn invisible" key={id}>
                <h3 className="tinyFont capitals">{card}</h3>
            </div>
        )
    })
    return(
        <div className="ServiceCards grid" id="ServiceCards">
            {services}
        </div>
    )
}

export default ServiceCards;


// WEBPACK FOOTER //
// ./src/components/ServiceCards.js